var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4791 8.80192C20.3854 3.98942 16.1875 1.82275 12.5 1.82275C12.5 1.82275 12.5 1.82275 12.4896 1.82275C8.81248 1.82275 4.60414 3.979 3.51039 8.7915C2.29164 14.1665 5.58331 18.7186 8.56248 21.5832C9.66664 22.6457 11.0833 23.1769 12.5 23.1769C13.9166 23.1769 15.3333 22.6457 16.4271 21.5832C19.4062 18.7186 22.6979 14.1769 21.4791 8.80192ZM12.5 14.0207C10.6875 14.0207 9.21873 12.5519 9.21873 10.7394C9.21873 8.92692 10.6875 7.45817 12.5 7.45817C14.3125 7.45817 15.7812 8.92692 15.7812 10.7394C15.7812 12.5519 14.3125 14.0207 12.5 14.0207Z",
    fill: "#B794FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.40b9875c79eb5f63fa2d99304599c931.svg";
export { ForwardRef as ReactComponent };